import { FormFieldTypes } from "../../../../data/formFieldType";

export const AdditionalFieldsData = {
  name: "AdditionalInfo",
  initialState: {
    searchByRequirementName: "",
    label: "",
    instructions: "",
  },
  formFields: [
    {
      id: "label",
      lable: "Label",
      Field_Name: "Label",
      fieldType: FormFieldTypes.INPUT,
      dataField: "label",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-lg-12 mb-3 pr-0",
      },
    },
    {
      id: "instructions",
      lable: "Instructions",
      Field_Name: "Instructions",
      fieldType: FormFieldTypes.CKEDITOR,
      dataField: "instructions",
      fieldSetting: {
        placeholder: "",
        allowSpace: false,
        // maxWords: 200,
      },
      validation: [],
      style: {
        containerCss: "col-md-12 mb-3 h-40",
      },
    },
    {
      id: "Input Fields",
      label: "Input Fields",
      Field_Name: "Input Fields",
      fieldType: FormFieldTypes.RADIOBUTTON,
      dataField: "Input Fields",
      fieldSetting: {
        placeholder: "",
        options: [
          { label: "Text Box", value: "TextBox", isDisable: false },
          {
            label: "L1-L4 Rating",
            value: "L1-L4Rating",
            isDisable: false,
            optionClass: "mr-3",
          },
          {
            label: "Tick Rating",
            value: "TickRating",
            isDisable: false,
            optionClass: "mr-3",
          },
        ],
      },
    //   validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-12 col-12 mb-4 mt-2 x-position radio-gap",
      },
    },
    {
      id: "Mandatory",
      label: "Mandatory",
      Field_Name: "Mandatory",
      fieldType: FormFieldTypes.RADIOBUTTON,
      dataField: "Mandatory",
      fieldSetting: {
        placeholder: "",
        options: [
          { label: "Yes", value: "yes", isDisable: false },
          { label: "No", value: "no", isDisable: false, optionClass: "mr-3" },
        ],
      },
    //   validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-12 col-12 mb-4 mt-2 x-position radio-gap",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
